module.exports = __webpack_public_path__ + "static/media/ic_edit.a26aebf4.svg";